
import React from "react";
import "./Success_Modal_2.css";
import { Modal } from "react-bootstrap";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";

function Success_Modal_2(props) {
  const { message, subMessage } = props;

  return (
    <div className="Successfull_Modal_sec">
      <Modal className="Successfull_Modal" {...props} size="sm" centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="lottie-holder">
            <Successfull_Lottie />
          </div>

          <p>{message}</p>
          <sub>{subMessage}</sub>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Success_Modal_2;